"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var renderer = function renderer(_ref) {
  var cellData = _ref.cellData;
  return /*#__PURE__*/_react["default"].createElement("div", null, cellData);
};

renderer.propTypes = {
  cellData: _propTypes["default"].string
};
renderer.defaultProps = {
  cellData: ''
};
var _default = renderer;
exports["default"] = _default;